export const PdqFilterTabs = {
    Products: 'products',
    Requests: 'requests'
};
